const COMMENTS = [
  {
    user: "前排嗑瓜子",
    tag: "力挺",
    mood: "支持",
    text: "看了完整时间线才懂，断章真的害人。这次真觉得当事人挺冤，把前后三分钟看完再说好吗？",
    ups: "2.1w",
    agree: 82,
  },
  {
    user: "路过的路人甲",
    tag: "存疑",
    mood: "观望",
    text: "声明写得挺诚恳，但细节对不上的地方还是不少，先让子弹飞一会儿，不急着站队。",
    ups: "1.4w",
    agree: 47,
  },
  {
    user: "显微镜观众",
    tag: "补刀",
    mood: "反驳",
    text: "逐帧看下来第三处明显没解释到位，这波回应与其说是澄清，不如说是把瓜越滚越大了。",
    ups: "9.6k",
    agree: 18,
  },
];

const SENTIMENT = [
  { label: "力挺派", pct: 68, color: "bg-primary-500" },
  { label: "中立观望", pct: 22, color: "bg-secondary-400" },
  { label: "反驳派", pct: 10, color: "bg-accent-500" },
];

export default function Opinion() {
  return (
    <section id="opinion" className="border-t border-background-200/70 bg-background-50 py-10 md:py-12">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between flex-wrap gap-3 mb-5 md:mb-6">
          <div>
            <p className="flex items-center gap-2 text-xs font-bold tracking-widest text-accent-600 uppercase">
              <i className="ri-compass-3-line" aria-hidden="true"></i> 网友怎么说
            </p>
            <h2 className="font-display font-black text-foreground-950 text-2xl md:text-3xl mt-2">舆论风向标</h2>
          </div>
          <p className="text-sm text-foreground-500 max-w-md">同一件事，热搜底下往往站着好几拨观点。这里截取高赞评论区原声，看看风向此刻吹向哪边。</p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-[340px_minmax(0,1fr)] gap-4 md:gap-5">
          {/* 左侧：声量分布 */}
          <aside className="rounded-2xl border border-background-200/70 bg-background-100/60 p-5 h-fit">
            <div className="flex items-center justify-between">
              <span className="text-sm font-semibold text-foreground-700">声量分布</span>
              <span className="flex items-center gap-1 text-xs text-foreground-500">
                <i className="ri-arrow-up-down-line" aria-hidden="true"></i> 样本 46.8w 条
              </span>
            </div>
            <div className="flex flex-col gap-4 mt-5">
              {SENTIMENT.map((s) => (
                <div key={s.label}>
                  <div className="flex items-center justify-between text-xs mb-1.5">
                    <span className="text-foreground-700 font-medium">{s.label}</span>
                    <span className="text-foreground-500">{s.pct}%</span>
                  </div>
                  <div className="h-2 rounded-full bg-background-200 overflow-hidden">
                    <div className={`h-full rounded-full ${s.color}`} style={{ width: `${s.pct}%` }}></div>
                  </div>
                </div>
              ))}
            </div>
            <div className="flex items-center gap-2 mt-6 rounded-xl bg-primary-50 p-3">
              <i className="ri-sparkling-2-line text-primary-600" aria-hidden="true"></i>
              <p className="text-xs text-primary-700 leading-relaxed">风向小结：声明公布后力挺声量抬升，但细节党仍在线逐条核实。</p>
            </div>
          </aside>

          {/* 右侧：高赞评论区原声 */}
          <div className="flex flex-col gap-3 md:gap-4">
            {COMMENTS.map((c) => (
              <article key={c.user} className="rounded-2xl border border-background-200/70 bg-background-100/40 p-4 md:p-5 hover:border-secondary-200 transition-colors">
                <div className="flex items-center gap-3 flex-wrap">
                  <span className="w-9 h-9 rounded-full bg-secondary-100 text-secondary-800 flex items-center justify-center text-sm font-bold">
                    {c.user.slice(0, 1)}
                  </span>
                  <div className="flex-1 min-w-0">
                    <p className="text-sm font-semibold text-foreground-900">{c.user}</p>
                    <p className="text-[11px] text-foreground-500">高赞评论 · 时间线围观现场</p>
                  </div>
                  <span
                    className={`rounded-full px-2.5 py-1 text-[11px] font-bold ${
                      c.mood === "支持"
                        ? "bg-primary-100 text-primary-700"
                        : c.mood === "观望"
                        ? "bg-secondary-100 text-secondary-700"
                        : "bg-accent-100 text-accent-700"
                    }`}
                  >
                    {c.mood} · {c.tag}
                  </span>
                </div>
                <p className="mt-3 text-sm md:text-[15px] leading-relaxed text-foreground-800">“{c.text}”</p>
                <div className="mt-3 flex items-center gap-4 text-[11px] text-foreground-500">
                  <span className="flex items-center gap-1 text-primary-600 font-medium">
                    <i className="ri-thumb-up-line" aria-hidden="true"></i> {c.ups} 赞同
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-reply-line" aria-hidden="true"></i> 回复
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-share-forward-line" aria-hidden="true"></i> 分享
                  </span>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}